module.exports = __webpack_public_path__ + "static/assets/9ace6ac1fcafca68f61a460a833b1ca1.svg";